<template>
  <QTextField
    v-model="localValue"
    :label="label"
    :hint="hint"
    :persistentHint="!!hint"
    :rules="rules"
    :placeholder="definition.DefaultValue"
    type="password"
    externaledit
    clearable
  />
</template>

<script>
import QTextField from "@/components/Inputs/QTextField.vue";

export default {
  name: "QAIFieldPassword",
  components: { QTextField },
  props: {
    value: { type: String, default: "" },
    definition: { type: Object, required: true },
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); },
    },
    label() {
      return this.definition.Description || this.definition.Name;
    },
    hint() {
      return this.definition.DefaultValue ? `Default: ${this.definition.DefaultValue}` : "";
    },
    rules() {
      return this.definition.IsRequired ? [v => !!v || `${this.definition.Name} is required`] : [];
    },
  },
};
</script>
